'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _class; /**
                   * Created by zfc on 2017/4/9.
                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _background = require('redux/modules/background');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromptPages = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch((0, _background.changeHeaderText)('艺品网主页')));
    return _promise2.default.all(promises);
  }
}]), _dec(_class = function (_Component) {
  (0, _inherits3.default)(PromptPages, _Component);

  function PromptPages() {
    (0, _classCallCheck3.default)(this, PromptPages);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PromptPages).call(this));
  }

  (0, _createClass3.default)(PromptPages, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_components.WarningPage, { text: '该功能尚未开放' });
    }
  }]);
  return PromptPages;
}(_react.Component)) || _class);
exports.default = PromptPages;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PromptPages/PromptPages.js
 ** module id = 1530
 ** module chunks = 0
 **/